<p-dialog
    [visible]="showDialog()"
    (visibleChange)="onVisibleChange($event)"
    [header]="dialogHeader()"
    [modal]="true"
    [style]="{ width: '700px' }"
    [closable]="!isForced()"
    [dismissableMask]="!isForced()"
    [closeOnEscape]="!isForced()">

    @if (notification(); as notification) {
        <div class="flex flex-column gap-4">
            <!-- Tags -->
            @if (notification.tags && notification.tags.length > 0) {
                <div class="flex flex-wrap gap-2">
                    @for (tag of notification.tags; track tag) {
                        <p-tag
                            [value]="getTagLabel(tag)"
                            [severity]="getTagSeverity(tag)"
                            [rounded]="true" />
                    }
                </div>
            }

            <!-- Meta info -->
            <div class="flex align-items-center gap-3 text-color-secondary text-sm">
                @if (notification.version) {
                    <span class="flex align-items-center gap-1">
                        <i class="pi pi-tag"></i>
                        v{{ notification.version }}
                    </span>
                }
                @if (notification.publishedAt) {
                    <span class="flex align-items-center gap-1">
                        <i class="pi pi-calendar"></i>
                        {{ notification.publishedAt | date:'mediumDate' }}
                    </span>
                }
            </div>

            <!-- Content -->
            <div class="notification-content" [innerHTML]="processedContent()"></div>
        </div>
    }

    <ng-template #footer>
        <div class="flex justify-content-between align-items-center w-full">
            <div>
                @if (notification(); as notification) {
                    <p-button
                        [label]="'NOTIFICATION.READ_MORE' | translate"
                        icon="pi pi-arrow-right"
                        iconPos="right"
                        [text]="true"
                        (onClick)="navigateToDetails(notification.id!)" />
                }
            </div>

            <div class="flex align-items-center gap-3">
                @if (notification(); as notification) {
                    @if (notification.actionUrl) {
                        <p-button
                            [label]="notification.actionLabel || ('NOTIFICATION.VIEW' | translate)"
                            icon="pi pi-external-link"
                            [text]="true"
                            (onClick)="navigateToAction(notification.actionUrl, notification.id!)" />
                    }
                }
                @if (isUnread()) {
                    <p-button
                        [label]="'NOTIFICATION.MARK_AS_READ' | translate"
                        icon="pi pi-check"
                        (onClick)="markAsRead(notification()!.id!)" />
                } @else {
                    <p-button
                        [label]="'CLOSE' | translate"
                        (onClick)="close()" />
                }
            </div>
        </div>
    </ng-template>
</p-dialog>
